import React from 'react';

function SortingControls({ sortBy, setSortBy, groupByState, setGroupByState }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6">
      <div className="bg-slate-50 rounded-lg border border-slate-200 p-4">
        <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
          <div className="flex items-center gap-3">
            <i className="fas fa-sort text-purple-600"></i>
            <span className="font-semibold text-gray-700">Sort by:</span>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-purple-600 focus:outline-none bg-white cursor-pointer"
            >
              <option value="state">Location (A-Z)</option>
              <option value="effectiveDate">Effective Date</option>
              <option value="status">Status</option>
              <option value="category">Category</option>
            </select>
          </div>

          <div className="flex items-center gap-3">
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={groupByState}
                onChange={(e) => setGroupByState(e.target.checked)}
                className="w-5 h-5 text-purple-600 border-gray-300 rounded focus:ring-purple-500 cursor-pointer"
              />
              <span className="ml-2 text-gray-700 font-medium">
                <i className="fas fa-layer-group text-purple-600 mr-2"></i>
                Group by Location
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SortingControls;
